import useFlatEntityData from "./useFlatEntityData";
import useSectorData from "./useSectorData";

export const useRegistryData = () => {
  const {
    data: mainCategory,
    loading: loadingMain,
    error: errorMain,
  } = useFlatEntityData("main_category");

  const {
    data: sector,
    loading: loadingSector,
    error: errorSector,
  } = useSectorData();

  const {
    data: otherCategories,
    loading: loadingOther,
    error: errorOther,
  } = useFlatEntityData("other_categories");

  return {
    mainCategory,
    sector,
    otherCategories,
    loading: loadingMain || loadingSector || loadingOther,
    error: errorMain || errorSector || errorOther,
  };
};

export default useRegistryData;
